import { render } from "./PhysicalPerformanceTrendsSimple.vue?vue&type=template&id=369cf890&scoped=true"
import script from "./PhysicalPerformanceTrendsSimple.vue?vue&type=script&lang=js"
export * from "./PhysicalPerformanceTrendsSimple.vue?vue&type=script&lang=js"

import "./PhysicalPerformanceTrendsSimple.vue?vue&type=style&index=0&id=369cf890&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369cf890"]])

export default __exports__